export default class SignUpPage {
    constructor() {
        return {
            template: require('../../../../views/sign-up/pages/p-sign-up.html'),
            controller: SignUpPageController,
            controllerAs: 'signUp'
        }
    }
}

class SignUpPageController {

    constructor($element) {
        this.$onInit = () => {
            $element.addClass('p-login');

            window.location.href = '/v5/#/auth/registration';
        }
    };
}

